<template>
	<v-card>
		<egranty-table
			toolbar-action-name="Dodaj paragraf"
			:items="paragraphs"
			:headers="headers"
			table-name="Paragrafy w tym naborze"
			:row-actions=actions
			@toolbarAction=openAddParagraph
			@deleteParagraph="deleteParagraph"
		></egranty-table>
		<egranty-input-field-popup
			:is-open.sync="addParagraphOpen"
			:title="'Dodaj paragraf'"
			:label="'Nazwa'"
			@save="addParagraph"
		></egranty-input-field-popup>
	</v-card>
</template>

<script>
	import EgrantyTable from "../../../../genericComponents/EgrantyTable";
	import EgrantyInputFieldPopup from "../../../../genericComponents/EgrantyInputFieldPopup";
	import {AgencyContestParagraph} from "../../../../api/generated/AgencyContestParagraph";

	export default {
		name: "AgencyContestParagraphsTable",
		components: {EgrantyInputFieldPopup, EgrantyTable},

		data () {
			return {
				paragraphs: [],
				headers: [
					{text: "Nazwa", value: "name"},
				],
				addParagraphOpen: false,

				actions: [
					{
						name: "deleteParagraph",
						icon: "delete"
					}
				]
			};
		},

		methods: {

			contestId () {
				return this.$route.params.id;
			},

			openAddParagraph () {
				this.addParagraphOpen = true;
			},

			addParagraph (name) {
				this.addParagraphOpen = false;
				AgencyContestParagraph.putParagraph(this, this.contestId(), name, successResponse => {
						this.$messagesBus.$emit("success", "Paragraf został pomyślnie dodany", successResponse);
						this.refresh();
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się dodać paragrafu", errorResponse);
					}
				);
			},

			deleteParagraph (paragraph) {
				AgencyContestParagraph.deleteParagraph(this, this.contestId(), paragraph.id, successResponse => {
						this.$messagesBus.$emit("success", "Paragraf został pomyślnie usunięty", successResponse);
						this.refresh();
					},
					errorResponse => {
						this.$messagesBus.$emit("error", errorResponse.message, errorResponse);
					}
				);
			},

			refresh () {
				AgencyContestParagraph.getAllParagraphs(
					this,
					this.contestId(),
					response => this.paragraphs = response
				);
			}
		},
		mounted () {
			this.refresh();
		},
	};
</script>

<style scoped>

</style>
